<div class="main-container">
  <h2 class="main-container-header">Are you sure you want to delete {{ data.name }}?</h2>
  <div class="main-container-text">
    <p>
      Deleting this workspace will remove any and all data associated with this workspace, including (but is not imited
      to):
    </p>
    <ul>
      <li>All teams and team rosters on the workspace.</li>
      <li>All email messages sent out from the workspace.</li>
      <li>All form, survey, and evaluation data associated with this workspace.</li>
    </ul>
    <p>People profiles and their person field values will be preserved and can be viewd from the Organization.</p>
    <p>
      <b>This action is permanent and cannot be undone.</b>
      If you are sure, please type "DELETE" in the field below.
    </p>
    <mat-form-field appearance="outline" class="value-description">
      <input data-testid="confirm-delete" matInput type="text" [(ngModel)]="textMatcherValue" />
    </mat-form-field>
  </div>
  <div class="button-container" mat-dialog-actions>
    <button
      mat-button
      class="delete-color"
      [mat-dialog-close]="deleteButtonClicked()"
      id="workspace-delete-modal-button"
      [disabled]="isDeleteButtonDisabled()"
    >
      Delete Workspace
    </button>
    <button type="button" mat-button [mat-dialog-close]="cancelButtonClicked()">Cancel</button>
  </div>
</div>
